<template>
  <div class="map-container">
    <div class="map-content">
      <!-- 地图组件 -->
      <bridge-map
        class="bridge-map"
        ref="bridgeMap"
        :bridge-markers="bridgeMarkers"
        :current-bridge-info="bridgeForm"
        :is-edit="isEdit"
        :marker="marker"
        :has-coordinates="!!bridgeForm.longitude && !!bridgeForm.latitude"
        :saved-areas="savedAreas"
        :area-type-name-map="areaTypeNameMap"
        :drawing-coordinates="drawingCoordinates"
        :drawing-mode.sync="isDrawingActive"
        :current-area-type.sync="areaForm.areaType"
        :current-geometry-type-prop="areaForm.geometryType"
        @map-ready="onMapReady"
        @map-click="onMapClick"
        @mouse-move="onMouseMove"
        @go-back="goBack"
        @show-bridge-info="showBridgeInfo"
        @edit-bridge="editBridge"
        @edit-area="editArea"
        @edit-current-area="editCurrentArea"
        @clear-drawing="clearDrawing"
        @update:drawing-coordinates="val => drawingCoordinates = val"
        @finish-drawing="handleFinishDrawing"
        @save-edited-area="handleSaveEditedArea"
        @cancel-editing="handleCancelEditing"
        @temp-update-areas="handleTempUpdateAreas">
      </bridge-map>
      
      <!-- 顶部导航条 -->
      <bridge-header
        class="bridge-header"
        ref="bridgeHeader"
        :is-edit="isEdit"
        :bridge-name="bridgeForm.bridgeName"
        :submitting="submitting"
        :is-location-picking-active="isLocationPickingActive"
        :is-drawing-active="isDrawingActive"
        :has-drawing="!!drawingCoordinates.length"
        :active-tab="activeTab"
        @go-back="goBack"
        @tab-change="handleTabChange"
        @toggle-location-picking="toggleLocationPicking"
        @toggle-drawing="startDrawing"
        @clear-drawing="clearDrawing"
        @save="submitForm"
        @show-alert-settings="showAlertSettings">
      </bridge-header>
      
      <!-- 桥梁信息面板 -->
      <bridge-info-panel
        class="bridge-info-panel"
        ref="infoPanel"
        :loading="loading"
        :is-edit="isEdit"
        :submitting="submitting"
        v-show="activeTab === 'info'"
        @collapse-change="handleInfoPanelCollapse"
        @layout-change="handleLayoutChange"
        @save="submitForm">
        <bridge-form
          ref="bridgeForm"
          v-model="bridgeForm"
          :is-edit="isEdit"
          :is-location-picking-active="isLocationPickingActive"
          :bridge-type-options="bridgeTypeOptions"
          @toggle-location-picking="toggleLocationPicking">
        </bridge-form>
      </bridge-info-panel>
      
      <!-- 区域管理面板 -->
      <area-panel
        class="area-panel"
        ref="areaPanel"
        :loading="loading"
        :is-drawing-active="isDrawingActive"
        :areas="savedAreas"
        :area-type-options="areaTypeOptions"
        :area-type-name-map="areaTypeNameMap"
        :drawing-coordinates="drawingCoordinates"
        :has-drawing-coordinates="!!drawingCoordinates.length"
        :is-editing="isEditingArea"
        :area-form="areaForm"
        :saving="submitting"
        :selected-area="selectedArea"
        :bridge-id="bridgeForm.id || currentBridgeId"
        v-show="activeTab === 'area'"
        @toggle-drawing="startDrawing"
        @clear-drawing="clearDrawing"
        @select-area="handleAreaSelect"
        @edit-area="editArea"
        @save-area="saveArea"
        @delete-area="deleteArea"
        @cancel-edit="handleCancelEditing"
        @change-area-type="changeAreaType"
        @change-area-color="handleAreaColorChange"
        @geometry-type-change="handleGeometryTypeChange"
        @select-point-icon="handlePointIconSelected"
        @point-icon-changed="handlePointIconChanged"
        @point-color-changed="handlePointColorChanged"
        @area-name-changed="handleAreaNameChanged"
        @collapse-change="handleAreaPanelCollapse"
        @layout-change="handleLayoutChange"
        @create-area-from-drawing="createAreaFromDrawing"
        @show-area-alert-settings="showAreaAlertSettings"
        @show-all-area-alert-settings="showAlertSettings"
        @clear-current-area="clearCurrentArea"
        @toggle-area-visibility="handleAreaVisibilityChange"
        @edit-current-area="editCurrentArea">
      </area-panel>
      

      
      <!-- 船舶黑白名单面板 -->
      <vessel-blacklist-panel
        class="blacklist-panel"
        ref="blacklistPanel"
        :bridge-id="bridgeForm.id || currentBridgeId"
        v-show="activeTab === 'blacklist'"
        @collapse-change="handleBlacklistPanelCollapse"
        @layout-change="handleLayoutChange"
        @close="handleCloseBlacklistPanel">
      </vessel-blacklist-panel>
      
      <!-- 地图工具栏 - 暂时隐藏 -->
      <!-- <map-toolbar
        class="map-toolbar"
        :vertical="true"
        :available-layers="mapLayers"
        @zoom="handleMapZoom"
        @reset-view="resetMapView"
        @tool-change="handleToolChange"
        @toggle-fullscreen="toggleFullscreen"
        @layer-visibility-change="handleLayerVisibilityChange">
      </map-toolbar> -->
      
      <!-- 区域告警规则弹窗 -->
      <!-- 已移除AreaAlertDialog组件，由AlertSettingsPanel和AlertRulesList替代 -->
      <!-- <area-alert-dialog
        :visible.sync="areaAlertDialogVisible"
        :bridge-id="currentBridgeId"
        :area="selectedArea"
        @close="handleAreaAlertClose">
      </area-alert-dialog> -->
    </div>
  </div>
</template>

<script>
import BridgeMap from '@/components/bridge/BridgeMap.vue';
import BridgeForm from '@/components/bridge/BridgeForm.vue';
import BridgeHeader from '@/components/bridge/BridgeHeader.vue';
import BridgeInfoPanel from '@/components/bridge/BridgeInfoPanel.vue';
import AreaPanel from '@/components/bridge/AreaPanel.vue';
import MapToolbar from '@/components/bridge/MapToolbar.vue';
import VesselBlacklistPanel from '@/components/bridge/VesselBlacklistPanel.vue';
import BridgeManagementJs from './BridgeManagement.js';

export default {
  name: 'BridgeManagement',
  components: {
    BridgeMap,
    BridgeForm,
    BridgeHeader,
    BridgeInfoPanel,
    AreaPanel,
    MapToolbar,
    VesselBlacklistPanel
  },
  mixins: [BridgeManagementJs]
};
</script>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.map-content {
  position: relative;
  width: 100%;
  height: 100%;
}

/* 确保地图组件有正确的尺寸和定位 */
.bridge-map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

/* 顶部导航条样式 */
.bridge-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  z-index: 1000;
}

/* 信息面板定位 */
.bridge-info-panel {
  position: absolute;
  top: 70px;
  left: 10px;
  z-index: 900;
}

/* 区域面板定位 */
.area-panel {
  position: absolute;
  top: 70px;
  left: 10px;
  z-index: 900;
}



/* 船舶黑名单面板定位 */
.blacklist-panel {
  position: absolute;
  top: 70px;
  left: 10px;
  z-index: 900;
}

/* 地图工具栏定位 */
.map-toolbar {
  position: absolute;
  top: 80px;
  right: 20px;
  z-index: 800;
}

/* 全屏模式样式 */
.map-content:-webkit-full-screen {
  width: 100%;
  height: 100%;
}

.map-content:-moz-full-screen {
  width: 100%;
  height: 100%;
}

.map-content:-ms-fullscreen {
  width: 100%;
  height: 100%;
}

.map-content:fullscreen {
  width: 100%;
  height: 100%;
}
</style> 